// Copyright (c) 2019, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

import {
  Spinner,
  Warning,
  SvgIcon,
  MetricsReportKPI,
} from '../'

import {
  decodeBase64
} from '../../utils'

const QUERY_METRICS = gql`
  query($metricSourceId: UUID!) {
    metrics(metricsource_Id: $metricSourceId, orderBy: "-created_at", first: 1) {
      edges {
        node {
          id
          description
          result
          createdAt
        }
      }
    }
  }
`


export const LatestKPIMetrics = ({ metricSourceId }) => (
  <Query query={QUERY_METRICS} variables={{ metricSourceId: decodeBase64(metricSourceId) }}>
    {({ loading, error, data }) => {
      if (loading) {
        return <Spinner type='tail' />
      }

      if (error) {
        return <Warning iconSize='x-small'>Error loading metric.</Warning>
      }

      if (data.metrics.edges.length === 0) {
        return (
          <div className='slds-grid stage-main' style={{ height: '100vh' }}>
            <SvgIcon
              variant='utility'
              symbol='info'
              size='x-small'
              className='slds-m-right_small'
            />
            No metric found.
          </div>
        )
      }

      let metric = data.metrics.edges[0].node

      return (
        <MetricsReportKPI
          description={metric.description}
          createdAt={metric.createdAt}
          data={JSON.parse(metric.result)["KPIs"]}
        />
      )
    }}
  </Query>
)



// WEBPACK FOOTER //
// ./src/components/latest-kpi-metrics/index.js